import type { AppError } from '../models';
import type { TFunction } from 'i18next';

/**
 * Mooie titel verzinnen voor als er iets misgaat
 */
export function getErrorTitle(error: AppError, t: TFunction): string {
  switch (error.type) {
    case 'database_init':
      return t('errors.database_init_title', 'Database Start Mislukt');
    case 'database_query':
      return t('errors.database_query_title', 'Database Fout');
    case 'camera_permission':
      return t('errors.camera_permission_title', 'Camera Toegang Geweigerd');
    case 'camera_unavailable':
      return t('errors.camera_unavailable_title', 'Camera Niet Beschikbaar');
    case 'network':
      return t('errors.network_title', 'Netwerk Fout');
    default:
      return t('errors.generic_title', 'Fout');
  }
}

/**
 * Uitleggen wat er aan de hand is (zonder te technisch te worden)
 */
export function getErrorMessage(error: AppError, t: TFunction): string {
  switch (error.type) {
    case 'database_init':
      return t('errors.database_init_message', 'Kon de producten database niet starten. Probeer het opnieuw.');
    case 'database_query':
      return t('errors.database_query_message', 'Kon geen data uit de database halen.');
    case 'camera_permission':
      return t('errors.camera_permission_message', 'Camera toegang is nodig om barcodes te scannen. Geef toestemming in je instellingen.');
    case 'camera_unavailable':
      return t('errors.camera_unavailable_message', 'Je camera doet het niet. Je kan nog wel gewoon handmatig zoeken.');
    case 'network':
      return t('errors.network_message', 'Geen internet verbinding. Sommige dingen doen het misschien niet.');
    default:
      return error.message || t('errors.generic_message', 'Er ging iets onverwachts mis.');
  }
}

/**
 * Wat moet er op de knop staan? (Probeer opnieuw, of ga weg)
 */
export function getErrorActionText(error: AppError, t: TFunction): string | null {
  if (!error.recoverable) {
    return null;
  }

  switch (error.type) {
    case 'database_init':
    case 'database_query':
    case 'network':
      return t('errors.action_retry', 'Opnieuw');
    case 'camera_permission':
      return t('errors.action_settings', 'Open Instellingen');
    default:
      return t('errors.action_retry', 'Opnieuw');
  }
}
